<template lang="pug">
  theme-provider(:theme="theme")
    main.main.main_contact
      header.main__header
        h1.main__title {{ $t('requestContact.title') }}
      .main__container
        .main__content
          form.form.form_contact(@submit.prevent="submitForm")
            .form__row.form__row_1
              .form__row_1-1
                label.form__label {{ $t('requestContact.labels.name') }}
                .form__field
                  input.form__input(
                    type="text"
                    v-model="$v.name.$model"
                  )
              .form__row_1-2
                label.form__label {{ $t('requestContact.labels.secondName') }}
                .form__field
                  input.form__input(
                    type="text"
                    v-model="secondName"
                  )
            .form__row
              label.form__label(v-html="$t('requestContact.labels.email')")
              .form__field
                input.form__input(
                  type="text"
                  v-model="$v.email.$model"
                  :class="{'form__input_error': $v.email.$error}"
                )
                span.form__error-text(v-if='$v.email.$error') {{ $t('requestContact.errors.email') }}
            .form__row
              label.form__label(v-html="$t('requestContact.labels.phone')")
              .form__field
                input.form__input(
                  type="text"
                  v-model="$v.phone.$model"
                  v-mask="'+380 ## ### ## ##'"
                  :class="{'form__input_error': $v.phone.$error}"
                )
                span.form__error-text(v-if='$v.phone.$error') {{ $t('requestContact.errors.phone') }}
            footer.form__footer
              a.link-back(@click="$router.go(-1)") {{ $t('requestContact.buttons.back') }}
              // to="requestSuccess"
              input.button.form__submit(
                type="submit"
                :value="$t('requestContact.buttons.continue')"
                :disabled="isDisabled"
              )
            .form__row
              Checkbox(
                :label="$t('requestContact.checkbox')"
                v-on:handleChange="agreement = !agreement"
                :checked="agreement",
                id="agreement"
              )
</template>

<script>
import { Checkbox } from '@/components/Checkbox'
import { theme } from '@/thems'
import { ThemeProvider } from 'vue-styled-components'
import { required, email, helpers, sameAs } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
const phoneRegex = helpers.regex('+38 044 555 55 55', /^\+380 \d{2} \d{3} \d{2} \d{2}$/)

export default {
  name: 'Request_Contact',
  data: () => ({
    theme: theme,
    agreement: true
  }),
  directives: {
    mask
  },
  validations: {
    name: {
      required
    },
    email: {
      email
    },
    phone: {
      required,
      phoneRegex
    },
    agreement: {
      sameAs: sameAs(() => true)
    }
  },
  methods: {
    submitForm () {
      this.$store.dispatch('requestService')
    }
  },
  computed: {
    isDisabled () {
      return this.$v.$invalid
    },
    name: {
      get () {
        return this.$store.getters.getContactFirstName
      },
      set (value) {
        this.$store.commit('updateContactFirstName', value)
      }
    },
    secondName: {
      get () {
        return this.$store.getters.getContactSecondName
      },
      set (value) {
        this.$store.commit('updateContactSecondName', value)
      }
    },
    email: {
      get () {
        return this.$store.getters.getContactEmail
      },
      set (value) {
        this.$store.commit('updateContactEmail', value)
      }
    },
    phone: {
      get () {
        return this.$store.getters.getContactPhone
      },
      set (value) {
        this.$store.commit('updateContactPhone', value)
      }
    }
  },
  components: {
    Checkbox,
    'theme-provider': ThemeProvider
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Request_Contact.vue